import { render, staticRenderFns } from "./CadastroFlorestal.vue?vue&type=template&id=5dbfce91&scoped=true"
import script from "./CadastroFlorestal.vue?vue&type=script&lang=js"
export * from "./CadastroFlorestal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbfce91",
  null
  
)

export default component.exports